import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js-cookie'

Vue.use(Vuex)

/* Vuex */
export default new Vuex.Store({
  state: {
    isDev: false,
    title: '',
    isLogin: false,
    user: null,
    isMobile: false, // 768px 이하는 모바일로 봄
    isTablet: false,
    selectedMarker: null
  },
  plugins: [
    createPersistedState({
      key: 'gm',
      getState: (key) => Cookies.getJSON(key),
      setState: (key, state) => Cookies.set(key, state, { expires: 3, secure: !state.isDev }) // secure only https
    })
  ],
  mutations: {
    setIsDev(state, isDev) {
      state.isDev = isDev === 'development'
    },
    setTitle(state, title) {
      state.title = title
    },
    setUser(state, user) {
      state.isLogin = user != null
      state.user = user
    },
    setIsMobile(state, width) {
      state.isMobile = (width <= 768)
    },
    setIsTablet(state, width) {
      state.isTablet = (width > 768 && width <= 1024)
    },
    setSelectedMarker(state, marker) {
      state.selectedMarker = marker
    }
  },
  actions: {
    logout(context) {
      context.commit('setUser', null)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js